export default {
    meta: {
        title: '',
        isShowHeader: false,
    },
};
